// extracted by mini-css-extract-plugin
export default {"deadlineDetails":"styles_deadlineDetails__gORms","headTitle":"styles_headTitle__nUwnq","date":"styles_date__KCYts","subTitle":"styles_subTitle__mgBEE"};